/** Deliberately not storage: a probe in another tab, or before a reload, did not create the flow this page shows. */
export type DomainsProbedThisPage = {
  mark: (domain: string) => void;
  includes: (domain: string) => boolean;
};

export const createDomainsProbedThisPage = (): DomainsProbedThisPage => {
  const probed = new Set<string>();

  return {
    mark: (domain) => {
      probed.add(domain);
    },
    includes: (domain) => probed.has(domain),
  };
};

export const domainsProbedThisPage = createDomainsProbedThisPage();
